// Demo mode bootstrap (non-module). Handles:
// - enabling demo (sets tokens/plan/user id)
// - seeding localStorage demo DB
// - injecting global demo banner
(function () {
  const DEMO_DB_KEY = 'demo_db_v1';
  const DEMO_FLAG_KEY = 'demo_mode';

  const DEMO_LOCKED_FEATURES = new Set([
    'ia_scanner',
    'ebook',
    'create_plan',
    'import_trades',
    'mt4',
    'mt5',
    'events',
    'change_plan',
    'gestion',
    'profile',
    'billing'
  ]);

  function isDemoMode() {
    try {
      // Check URL param first (highest priority during navigation)
      try {
        const params = new URLSearchParams(window.location.search || '');
        const demoParam = params.get('demo');
        if (demoParam === '1' || demoParam === 'true' || demoParam === 'yes') {
          try { localStorage.setItem(DEMO_FLAG_KEY, 'true'); } catch (e) {}
          return true;
        }
      } catch (e) {}
      
      // Check localStorage flag
      if (localStorage.getItem(DEMO_FLAG_KEY) === 'true') return true;
      
      // Check demo tokens
      const demoToken = 'demo_token_local';
      const demoUserId = 'demo_user';
      const token = sessionStorage.getItem('tfx_authToken') || sessionStorage.getItem('userToken') ||
                    localStorage.getItem('tfx_authToken') || localStorage.getItem('userToken');
      const userId = sessionStorage.getItem('tfx_userId') || sessionStorage.getItem('currentUserId') ||
                     localStorage.getItem('tfx_userId') || localStorage.getItem('currentUserId');
      
      if (token === demoToken || userId === demoUserId) {
        try { localStorage.setItem(DEMO_FLAG_KEY, 'true'); } catch (e) {}
        return true;
      }
      
      // Check demo DB existence
      if (localStorage.getItem(DEMO_DB_KEY)) {
        try { localStorage.setItem(DEMO_FLAG_KEY, 'true'); } catch (e) {}
        return true;
      }
      
      return false;
    } catch (e) { return false; }
  }

  function safeJsonParse(s, fallback) {
    try { return JSON.parse(s); } catch { return fallback; }
  }

  function getSeed() {
    return (typeof window !== 'undefined' && window.DEMO_DB_SEED) ? window.DEMO_DB_SEED : null;
  }

  function ensureDemoDbSeeded() {
    try {
      const existing = localStorage.getItem(DEMO_DB_KEY);
      if (existing) return;
      const seed = getSeed();
      if (seed) {
        localStorage.setItem(DEMO_DB_KEY, JSON.stringify(seed));
      } else {
        // minimal fallback seed
        localStorage.setItem(DEMO_DB_KEY, JSON.stringify({ version: 1, users: [], accounts: [], trades: [], daily_notes: [], payouts: [], installations: [] }));
      }
    } catch (e) {
      // ignore
    }
  }

  function ensureDemoIdentityKeys() {
    const demoUserId = 'demo_user';
    const demoToken = 'demo_token_local';
    const demoEmail = 'demo@tripulacionfx.com';
    const demoUsername = 'DEMO';

    try {
      // Old auth keys
      if (!sessionStorage.getItem('userToken')) sessionStorage.setItem('userToken', demoToken);
      if (!sessionStorage.getItem('currentUserId')) sessionStorage.setItem('currentUserId', demoUserId);
      if (!localStorage.getItem('userToken')) localStorage.setItem('userToken', demoToken);
      if (!localStorage.getItem('currentUserId')) localStorage.setItem('currentUserId', demoUserId);

      // App session fallback keys
      if (!sessionStorage.getItem('userEmail')) sessionStorage.setItem('userEmail', demoEmail);
      if (!localStorage.getItem('userEmail')) localStorage.setItem('userEmail', demoEmail);
      if (!localStorage.getItem('userName')) localStorage.setItem('userName', demoUsername);

      // New auth keys (used on journal.html)
      if (!sessionStorage.getItem('tfx_authToken')) sessionStorage.setItem('tfx_authToken', demoToken);
      if (!sessionStorage.getItem('tfx_token')) sessionStorage.setItem('tfx_token', demoToken);
      if (!sessionStorage.getItem('tfx_userId')) sessionStorage.setItem('tfx_userId', demoUserId);
      if (!localStorage.getItem('tfx_authToken')) localStorage.setItem('tfx_authToken', demoToken);
      if (!localStorage.getItem('tfx_token')) localStorage.setItem('tfx_token', demoToken);
      if (!localStorage.getItem('tfx_userId')) localStorage.setItem('tfx_userId', demoUserId);

      // Plans (several places use userPlan)
      localStorage.setItem('userPlan', 'unlimited');
      localStorage.setItem('user_plan', 'unlimited');

      // Clear session-expired flag to allow demo access
      localStorage.removeItem('_sessionExpired');
    } catch (e) {
      // ignore
    }
  }

  function showUpgradeUnlimitedMessage(featureLabel) {
    const title = 'Actualiza a UNLIMITED';
    const msg = `Actualiza a UNLIMITED para desbloquear esta funcionalidad${featureLabel ? `: ${featureLabel}` : ''}.`;

    try {
      if (window.showAlert && typeof window.showAlert === 'function') {
        window.showAlert(title, msg, 'warning');
        return;
      }
      if (window.showNotification && typeof window.showNotification === 'function') {
        window.showNotification(`${title} — ${msg}`, 'warning', 4000);
        return;
      }
      if (window.showToast && typeof window.showToast === 'function') {
        window.showToast(`${title} — ${msg}`, 'warning', 4000);
        return;
      }
    } catch (e) {
      // ignore
    }
  }

  // Returns true if blocked (i.e., should stop the action)
  function demoGate(featureKey, featureLabel) {
    if (!isDemoMode()) return false;
    if (!featureKey) return false;
    if (!DEMO_LOCKED_FEATURES.has(featureKey)) return false;
    showUpgradeUnlimitedMessage(featureLabel);
    return true;
  }

  function isAuthenticated() {
    try {
      const newToken = sessionStorage.getItem('tfx_authToken') || localStorage.getItem('tfx_authToken');
      const newUserId = sessionStorage.getItem('tfx_userId') || localStorage.getItem('tfx_userId');
      const oldToken = sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
      const oldUserId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');
      return (newToken && newUserId) || (oldToken && oldUserId);
    } catch (e) {
      return false;
    }
  }

  function isProtectedPage() {
    try {
      const path = (window.location && window.location.pathname) ? window.location.pathname.toLowerCase() : '';
      // Support both with and without .html extension
      return path.endsWith('/journal') || path.endsWith('/journal.html') ||
             path.endsWith('/gestion') || path.endsWith('/gestion.html') ||
             path.endsWith('/perfil') || path.endsWith('/perfil.html');
    } catch (e) {
      return false;
    }
  }

  function lockAndRedirectUnauthed() {
    if (isDemoMode()) return;
    if (!isProtectedPage()) return;
    if (isAuthenticated()) return;
    try {
      const styleId = 'demo-auth-blocked-style';
      if (!document.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = `
          html.demo-auth-blocked body { overflow: hidden !important; }
          html.demo-auth-blocked body > * { display: none !important; }
        `;
        document.head.appendChild(style);
      }
      document.documentElement.classList.add('demo-auth-blocked');
    } catch (e) {}

    try { localStorage.setItem('_sessionExpired', 'true'); } catch (e) {}
    try { window.location.href = '/'; } catch (e) {}
  }

  function attachDemoFeatureGuards() {
    if (!isDemoMode()) return;

    const bindClickBlock = (el, featureKey, label) => {
      if (!el) return;
      // Try to override inline onclick (if any)
      try {
        el.onclick = function (e) {
          if (demoGate(featureKey, label)) {
            try { e.preventDefault(); } catch (err) {}
            try { e.stopPropagation(); } catch (err) {}
            try { e.stopImmediatePropagation(); } catch (err) {}
            return false;
          }
          return true;
        };
      } catch (e) {}

      // Also attach capture listener to stop other handlers
      try {
        el.addEventListener('click', function (e) {
          if (demoGate(featureKey, label)) {
            try { e.preventDefault(); } catch (err) {}
            try { e.stopPropagation(); } catch (err) {}
            try { e.stopImmediatePropagation(); } catch (err) {}
          }
        }, true);
      } catch (e) {}
    };

    const disablePlanChangeButtons = () => {
      const markDisabled = (el) => {
        if (!el) return;
        try {
          el.setAttribute('disabled', 'disabled');
          el.setAttribute('aria-disabled', 'true');
          el.classList.add('opacity-50', 'cursor-not-allowed');
        } catch (e) {}
      };

      // Pricing buttons on inicio.html
      markDisabled(document.getElementById('btn-free'));
      markDisabled(document.getElementById('btn-pro'));
      markDisabled(document.getElementById('btn-unlimited'));

      // Any plan upgrade buttons generated in perfil.html
      try {
        document.querySelectorAll('button[onclick*="handlePlanUpgrade"]').forEach(btn => {
          markDisabled(btn);
        });
      } catch (e) {}

      // Buttons that literally say Cambiar a Pro/Free
      try {
        const textTargets = ['cambiar a pro', 'cambiar a free', 'cambiar a gratis', 'actualizar plan'];
        document.querySelectorAll('button').forEach(btn => {
          const txt = (btn.textContent || '').trim().toLowerCase();
          if (textTargets.some(t => txt.includes(t))) {
            markDisabled(btn);
          }
        });
      } catch (e) {}

      // Guard handlers if they exist
      try {
        if (window.handlePlanUpgrade && !window.handlePlanUpgrade._demoWrapped) {
          const original = window.handlePlanUpgrade;
          const wrapped = function() {
            if (demoGate('change_plan', 'Cambiar de Plan')) return;
            return original.apply(this, arguments);
          };
          wrapped._demoWrapped = true;
          window.handlePlanUpgrade = wrapped;
        }
      } catch (e) {}

      try {
        if (window.handlePricingAction && !window.handlePricingAction._demoWrapped) {
          const original = window.handlePricingAction;
          const wrapped = function() {
            if (demoGate('change_plan', 'Cambiar de Plan')) return;
            return original.apply(this, arguments);
          };
          wrapped._demoWrapped = true;
          window.handlePricingAction = wrapped;
        }
      } catch (e) {}
    };

    const doAttach = () => {
      bindClickBlock(document.getElementById('tradeControlBtn'), 'ia_scanner', 'IA Scanner');
      bindClickBlock(document.getElementById('downloadEbookBtn'), 'ebook', 'Descargar eBook');
      bindClickBlock(document.getElementById('ebookBtn'), 'ebook', 'Descargar eBook');
      bindClickBlock(document.getElementById('followPlanBtn'), 'create_plan', 'Crear Plan');
      bindClickBlock(document.getElementById('btnImportTradesModal'), 'import_trades', 'Importar Trades');
      bindClickBlock(document.getElementById('syncEventsBtn'), 'events', 'Eventos');

      try {
        document.querySelectorAll('.platform-btn[data-platform="mt4"]').forEach(btn => bindClickBlock(btn, 'mt4', 'MetaTrader 4'));
        document.querySelectorAll('.platform-btn[data-platform="mt5"]').forEach(btn => bindClickBlock(btn, 'mt5', 'MetaTrader 5'));
      } catch (e) {
        // ignore
      }

      // Change plan buttons (Cambiar a Pro/Free)
      bindClickBlock(document.getElementById('btn-free'), 'change_plan', 'Cambiar de Plan');
      bindClickBlock(document.getElementById('btn-pro'), 'change_plan', 'Cambiar de Plan');
      bindClickBlock(document.getElementById('btn-unlimited'), 'change_plan', 'Cambiar de Plan');

      // Generic locked elements via data-demo-lock
      try {
        document.querySelectorAll('[data-demo-lock]').forEach(el => {
          const key = (el.getAttribute('data-demo-lock') || '').trim();
          const label = el.getAttribute('data-demo-lock-label') || el.textContent?.trim() || 'Funcionalidad';
          bindClickBlock(el, key, label);
        });
      } catch (e) {}

      disablePlanChangeButtons();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', doAttach);
    } else {
      doAttach();
    }

    // Retry for dynamic plan buttons
    try {
      let tries = 0;
      const retry = setInterval(() => {
        tries += 1;
        disablePlanChangeButtons();
        if (tries >= 6) clearInterval(retry);
      }, 800);
    } catch (e) {}

    // Global capture guard to avoid navigation flash
    try {
      if (!document._demoLinkGuardAttached) {
        document._demoLinkGuardAttached = true;
        document.addEventListener('click', (e) => {
          if (!isDemoMode()) return;
          const target = e.target && e.target.closest ? e.target.closest('[data-demo-lock]') : null;
          if (target) {
            const key = (target.getAttribute('data-demo-lock') || '').trim();
            const label = target.getAttribute('data-demo-lock-label') || target.textContent?.trim() || 'Funcionalidad';
            if (demoGate(key, label)) {
              try { e.preventDefault(); } catch (err) {}
              try { e.stopPropagation(); } catch (err) {}
              try { e.stopImmediatePropagation(); } catch (err) {}
            }
          }
        }, true);
      }
    } catch (e) {}
  }

  function enableDemoMode() {
    try { localStorage.setItem(DEMO_FLAG_KEY, 'true'); } catch (e) {}
    try { localStorage.removeItem('_sessionExpired'); } catch (e) {}
    ensureDemoDbSeeded();
    ensureDemoIdentityKeys();
  }

  function clearDemoDataOnly() {
    try {
      localStorage.removeItem(DEMO_FLAG_KEY);
      localStorage.removeItem(DEMO_DB_KEY);

      // demo identity keys (only those we set)
      const keysToRemove = [
        'userToken', 'currentUserId',
        'tfx_authToken', 'tfx_token', 'tfx_userId',
        'userEmail', 'userName',
        'userPlan', 'user_plan'
      ];
      for (const k of keysToRemove) {
        localStorage.removeItem(k);
        try { sessionStorage.removeItem(k); } catch (e) {}
      }

      // Any stray demo_* keys
      const toDelete = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith('demo_')) toDelete.push(k);
      }
      toDelete.forEach(k => localStorage.removeItem(k));
    } catch (e) {
      // ignore
    }
  }

  function clearDemoArtifactsOnly() {
    try {
      localStorage.removeItem(DEMO_FLAG_KEY);
      localStorage.removeItem(DEMO_DB_KEY);

      // Any stray demo_* keys
      const toDelete = [];
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (k && k.startsWith('demo_')) toDelete.push(k);
      }
      toDelete.forEach(k => localStorage.removeItem(k));
    } catch (e) {
      // ignore
    }
  }

  function resetDemoMode() {
    try {
      localStorage.setItem(DEMO_FLAG_KEY, 'true');
      // Keep demo_mode true, but reset DB
      localStorage.removeItem(DEMO_DB_KEY);
    } catch (e) {}
    ensureDemoDbSeeded();
    ensureDemoIdentityKeys();
    try { location.reload(); } catch (e) {}
  }

  function exitDemoToRegister() {
    clearDemoDataOnly();
    try { sessionStorage.setItem('demo_exited', 'true'); } catch (e) {}
    try { window.location.href = '/auth?tab=register'; } catch (e) {}
  }

  function exitDemoToHome() {
    try {
      if (window.showConfirm && typeof window.showConfirm === 'function') {
        window.showConfirm(
          'Salir de DEMO',
          '¿Seguro que quieres salir del modo DEMO? Se borrarán los datos de demo.',
          'Salir',
          'Cancelar',
          'warning'
        ).then((confirmed) => {
          if (!confirmed) return;
          clearDemoDataOnly();
          try { sessionStorage.setItem('demo_exited', 'true'); } catch (e) {}
          try { window.location.href = '/'; } catch (e) {}
        });
        return;
      }
    } catch (e) {}

    if (window.showAlert) {
      window.showAlert('Confirmación requerida', 'No se pudo abrir el diálogo de confirmación.', 'warning');
    }
  }

  function injectDemoBanner() {
    if (!isDemoMode()) return;

    function doInject() {
      if (!document || !document.body) return;
      if (document.getElementById('demo-banner')) return;

      const style = document.createElement('style');
      style.textContent = `
        #demo-banner{position:fixed;top:var(--launch-banner-height,0px);left:0;right:0;z-index:99999;background:linear-gradient(135deg,#06b6d4 0%,#3b82f6 50%,#a855f7 100%);color:#fff;padding:12px 16px;box-shadow:0 2px 10px rgba(0,0,0,.25);}
        #demo-banner .demo-wrap{max-width:1200px;margin:0 auto;display:flex;align-items:center;gap:14px;justify-content:space-between;flex-wrap:wrap;}
        #demo-banner .demo-text{font-weight:600;}
        #demo-banner .demo-actions{display:flex;gap:10px;flex-wrap:wrap;}
        #demo-banner button{border:none;border-radius:10px;padding:8px 12px;font-weight:700;cursor:pointer;display:inline-flex;align-items:center;gap:8px;}
        #demo-banner .primary{background:#fff;color:#0f172a;}
        #demo-banner .secondary{background:rgba(255,255,255,.18);color:#fff;border:1px solid rgba(255,255,255,.28);}
        #demo-banner .danger{background:#f87171;color:#fff;border:1px solid #ef4444;}
        #demo-banner .danger:hover{background:#ef4444;}
        body.demo-mode-padding{padding-top:calc(var(--launch-banner-height,0px) + var(--demo-banner-height,0px)) !important;}
        @media (max-width: 640px){
          #demo-banner{padding:8px 12px;}
          #demo-banner .demo-wrap{gap:8px;}
          #demo-banner .demo-text{font-size:12px;}
          #demo-banner .demo-actions{width:100%;}
          #demo-banner button{flex:1;justify-content:center;font-size:12px;padding:8px 10px;}
        }
      `;
      document.head.appendChild(style);

      const banner = document.createElement('div');
      banner.id = 'demo-banner';
      banner.innerHTML = `
        <div class="demo-wrap">
          <div class="demo-text">Estás en modo DEMO — todos los datos son de ejemplo</div>
          <div class="demo-actions">
            <button class="primary" id="demo-register-btn">Crear Cuenta Gratis</button>
            <button class="secondary" id="demo-reset-btn">
              <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M21 12a9 9 0 1 1-2.64-6.36" />
                <polyline points="21 3 21 9 15 9" />
              </svg>
              Reiniciar Demo
            </button>
            <button class="danger" id="demo-exit-btn">
              <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                <polyline points="10 17 15 12 10 7" />
                <line x1="15" y1="12" x2="3" y2="12" />
              </svg>
              Salir de DEMO
            </button>
          </div>
        </div>
      `;

      document.body.insertBefore(banner, document.body.firstChild);
      document.body.classList.add('demo-mode-padding');

      const updateDemoBannerOffset = () => {
        const el = document.getElementById('demo-banner');
        const height = el ? el.offsetHeight : 0;
        document.documentElement.style.setProperty('--demo-banner-height', `${height}px`);
      };

      updateDemoBannerOffset();
      try { window.addEventListener('resize', updateDemoBannerOffset); } catch (e) {}

      const reg = document.getElementById('demo-register-btn');
      const reset = document.getElementById('demo-reset-btn');
      const exit = document.getElementById('demo-exit-btn');
      if (reg) reg.addEventListener('click', exitDemoToRegister);
      if (reset) reset.addEventListener('click', resetDemoMode);
      if (exit) exit.addEventListener('click', exitDemoToHome);

      // After banner injection, attach feature guards on this page.
      attachDemoFeatureGuards();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', doInject);
    } else {
      doInject();
    }
  }

  // Expose helpers
  try {
    window.enableDemoMode = enableDemoMode;
    window.isDemoMode = isDemoMode;
    window.demoGate = demoGate;
    window.showUpgradeUnlimitedMessage = showUpgradeUnlimitedMessage;
    window.injectDemoBanner = injectDemoBanner;
    window.resetDemoMode = resetDemoMode;
    window.exitDemoToRegister = exitDemoToRegister;
    window.exitDemoToHome = exitDemoToHome;
  } catch (e) {}

  // If a real (non-demo) identity is present, disable demo mode and reload to switch clients.
  try {
    const demoToken = 'demo_token_local';
    const demoUserId = 'demo_user';
    const ids = [
      sessionStorage.getItem('tfx_userId'),
      localStorage.getItem('tfx_userId'),
      sessionStorage.getItem('currentUserId'),
      localStorage.getItem('currentUserId')
    ].filter(Boolean);
    const tokens = [
      sessionStorage.getItem('tfx_authToken'),
      localStorage.getItem('tfx_authToken'),
      sessionStorage.getItem('userToken'),
      localStorage.getItem('userToken')
    ].filter(Boolean);
    const hasRealIdentity = ids.some(id => id !== demoUserId) || tokens.some(t => t !== demoToken);

    if (isDemoMode() && hasRealIdentity) {
      clearDemoArtifactsOnly();
      const banner = document.getElementById('demo-banner');
      if (banner && banner.parentNode) banner.parentNode.removeChild(banner);
      try { document.body.classList.remove('demo-mode-padding'); } catch (e) {}
      try { document.documentElement.style.setProperty('--demo-banner-height', '0px'); } catch (e) {}
      try { window.location.reload(); } catch (e) {}
      return;
    }
  } catch (e) {}

  // If demo already enabled, ensure consistency and inject banner.
  if (isDemoMode()) {
    ensureDemoDbSeeded();
    ensureDemoIdentityKeys();
    injectDemoBanner();
    attachDemoFeatureGuards();
    // Block access to restricted pages in demo
    try {
      const path = (window.location && window.location.pathname) ? window.location.pathname.toLowerCase() : '';
      if (path.endsWith('/gestion') || path.endsWith('/perfil')) {
        showUpgradeUnlimitedMessage('Acceso restringido');
        setTimeout(() => {
          try { window.location.href = './journal'; } catch (e) {}
        }, 600);
      }
    } catch (e) {}
  }

  // If demo is off (e.g., back from register), clean stale banner/guards on pageshow
  try {
    window.addEventListener('pageshow', () => {
      if (isDemoMode()) return;
      // Remove demo tokens that might persist after back navigation
      try {
        const demoToken = 'demo_token_local';
        const demoUserId = 'demo_user';
        const tfxToken = sessionStorage.getItem('tfx_authToken') || localStorage.getItem('tfx_authToken');
        const tfxUserId = sessionStorage.getItem('tfx_userId') || localStorage.getItem('tfx_userId');
        const oldToken = sessionStorage.getItem('userToken') || localStorage.getItem('userToken');
        const oldUserId = sessionStorage.getItem('currentUserId') || localStorage.getItem('currentUserId');

        const isDemoIdentity = (tfxToken === demoToken || oldToken === demoToken || tfxUserId === demoUserId || oldUserId === demoUserId);
        if (isDemoIdentity) {
          clearDemoDataOnly();
        }
      } catch (e) {}

      const banner = document.getElementById('demo-banner');
      if (banner && banner.parentNode) {
        banner.parentNode.removeChild(banner);
      }
      try { document.body.classList.remove('demo-mode-padding'); } catch (e) {}
      try { document.documentElement.style.setProperty('--demo-banner-height', '0px'); } catch (e) {}

      // If demo was exited and user is not authenticated, force login redirect on protected pages
      const exited = (() => {
        try { return sessionStorage.getItem('demo_exited') === 'true'; } catch (e) { return false; }
      })();

      if (exited && isProtectedPage()) {
        if (isAuthenticated()) {
          try { sessionStorage.removeItem('demo_exited'); } catch (e) {}
        } else {
          try { localStorage.setItem('_sessionExpired', 'true'); } catch (e) {}
          try { window.location.href = '/auth?tab=register'; } catch (e) {}
          return;
        }
      }

      // Second control: if unauthenticated, lock and redirect immediately
      lockAndRedirectUnauthed();
    });
  } catch (e) {}

  // Extra guards on visibility and short interval to avoid BFCache flashes
  try {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) lockAndRedirectUnauthed();
    });
  } catch (e) {}

  try {
    let guardRuns = 0;
    const guardTimer = setInterval(() => {
      guardRuns += 1;
      lockAndRedirectUnauthed();
      if (guardRuns >= 5) clearInterval(guardTimer);
    }, 1000);
  } catch (e) {}
})();
